import React from 'react';
import '../css/switchContactCard.css';
import RoundButton from '../../../button/round-button/ts/roundButton';

export interface SwitchContactItem {
  id: string;
  description: string;
  buttonText: string;
  onButtonClick?: () => void;
}

interface SwitchContactCardProps {
  items?: SwitchContactItem[];
}

const defaultItems: SwitchContactItem[] = [];

const SwitchContactCard: React.FC<SwitchContactCardProps> = ({ items = defaultItems }) => {
  return (
    <div className="scl--web-component-switch-contact-card-container">
      <div className="scl--web-component-switch-contact-content-wrapper">
        {items.map((item, index) => (
          <div key={item.id} className="scl--web-component-switch-contact-item">
            <div className="scl--web-component-switch-contact-item-content">
              <p className="scl--web-component-switch-contact-description">{item.description}</p>
              <RoundButton
                text={item.buttonText}
                onClick={item.onButtonClick}
                className="scl--web-component-switch-contact-button"
                showIcon={false}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SwitchContactCard;
